import {BaseLayerSelector, useDownloadMapAsPng} from "base/component/geo";
import useTheme from "@mui/material/styles/useTheme";

import Grid from "@mui/material/Grid";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MainMapDownloadPngAction from "./MainMapDownloadPngAction";

export const MainMapActions = ({mapObjectRef, mapRef, showMapActions = false}) => {
    const theme = useTheme();

    const {
        setConfig: setConfigMapAsPng,
        download: handleDownloadMapAsPng,
        generate: generateMapAsPng,
        getDimensions: getMapAsPngDimensions,
    } = useDownloadMapAsPng();

    setConfigMapAsPng(mapObjectRef.current, mapRef.current);

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
                bgcolor: theme.palette.primary.lighter,
                borderBottom: `1px solid ${theme.palette.primary.light}`,
                height: "50px",
            }}
        >
            <Typography sx={{pl: 3, pt: 1, pb: 1}} variant="h6">
                Layers
            </Typography>
            {showMapActions && (
                <ButtonGroup variant="outlined" aria-label="map button group">
                    <Divider orientation="vertical" flexItem />
                    <BaseLayerSelector />
                    <Divider orientation="vertical" flexItem />
                    <MainMapDownloadPngAction
                        onDownloadMapAsPng={handleDownloadMapAsPng}
                    />
                </ButtonGroup>
            )}
        </Grid>
    );
};
